import {asset} from 'imba';
import url from './companies.png';
export default asset({
	url: url,
	type: 'image',
	width: 1204,
	height: 282,
	toString: function(){ return this.url;}
})